import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["task", "onClick", "checkAndCompleteTask", "disabled", "children"];
import Routes from 'ContentUtils/Routes';
import { Button } from 'foundations-components/transitional/components/Button';
import { useTaskLink } from 'setup-guide-components/hooks/hub';
import { useFetchActiveThemePath } from '../../../hooks/useFetchActiveTheme';
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectYourStyleV2Button = _ref => {
  let {
      task,
      onClick,
      disabled,
      children
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    id,
    openLinkInNewTab,
    handholdingEnabled,
    handholdingGroupKeyOverride,
    handholdingSource
  } = task;
  const activeThemePath = useFetchActiveThemePath();
  // always override task link
  const themeEditorUrl = Routes.themeEditor(String(activeThemePath), {
    tourId: 'edit-theme-settings'
  });
  const href = useTaskLink(themeEditorUrl, id, handholdingEnabled, handholdingGroupKeyOverride, handholdingSource);
  return /*#__PURE__*/_jsx(Button, Object.assign({
    disabled: disabled || !activeThemePath,
    external: openLinkInNewTab,
    href: href,
    onClick: onClick
  }, buttonProps, {
    children: children
  }));
};